import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Tab from './CategoriesTab';
import Form from './CategoryForm';

function CategoriesRouter() {
  return (
    <Switch>
      <Route exact path="/categories" component={Tab} />
      <Route exact path="/categories/new" component={Form} />
      <Route exact path="/categories/:id" component={Form} />
      <Redirect to="/categories" />
    </Switch>
  );
}

export default CategoriesRouter;



// WEBPACK FOOTER //
// ./src/containers/Categories/index.js